"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var perks = [
    {
        description: "UK only roadside assistance offered when you are more than 1/4 mile from home",
        boldDescription: "more than 1/4 mile",
        level: {
            local: {
                included: true
            },
            uk: {
                included: true
            },
            eu: {
                included: true
            },
        },
    },
    {
        description: "Recovery to a garage up to 10 miles from the breakdown location",
        boldDescription: "up to 10 miles",
        level: {
            local: {
                included: true
            },
            uk: {
                included: true
            },
            eu: {
                included: true
            },
        },
    },
    {
        description: "Home cover",
        level: {
            local: {
                included: false,
            },
            uk: {
                included: true
            },
            eu: {
                included: true
            },
        }
    },
    {
        description: "Recovery to any UK destination",
        level: {
            local: {
                included: false,
            },
            uk: {
                included: true
            },
            eu: {
                included: true
            },
        },
    },
    {
        description: "Hire car, alternate transport or overnight accommodation",
        level: {
            local: {
                included: false,
            },
            uk: {
                included: true,
            },
            eu: {
                included: true,
            },
        }
    },
    {
        description: "European breakdown cover",
        level: {
            local: {
                included: false,
            },
            uk: {
                included: false,
            },
            eu: {
                included: true,
            },
        }
    }
];
exports.default = perks;
//# sourceMappingURL=BreakdownCoverPerks.js.map


//////////////////
// WEBPACK FOOTER
// ../falcon-plugins/plugin-falcon-journey/dist/widgets/annual/motor/optionalExtras/BreakdownCoverPerks.js
// module id = 3220
// module chunks = 0